import { GridColDef } from "@mui/x-data-grid-pro";
import {
  CheckIcon,
  GKButton,
  GKClientDataGrid,
  GKModal,
  GKTextField,
  Grid2,
  RupeeIcon,
  Typography,
} from "components";
import { MinesFee } from "interfaces/Revenue";
import { Controller, useFormContext } from "react-hook-form";
import { numberToCurrency } from "utils";
import { GKModalProps } from "utils/commonInterface";
import { extraColumnsField } from "utils/helpers";

interface Props {
  selected: string[];
  setSelected: (selected: string[]) => void;
  minesFeeData: MinesFee[];
  loading: boolean;
  totalAmount: number;
}

const MinesFeeModal = ({
  open,
  setOpen,
  minesFeeData,
  loading,
  selected,
  setSelected,
  totalAmount,
}: GKModalProps & Props) => {
  const form = useFormContext();

  const columns: GridColDef[] = [
    { ...extraColumnsField("Fee Plan", "name", 200, 1) },
    {
      ...extraColumnsField("Date Range", "date", 200, 1),
      valueGetter: ({ row }) => `${row.startDate} - ${row.endDate}`,
    },
    {
      ...extraColumnsField("Amount", "managementFeeAmount", 200, 1),
      valueGetter: ({ row }) => numberToCurrency(row.managementFeeAmount),
    },
  ];

  return (
    <GKModal
      modalTitle="Deduct Management Fees"
      width={"700px"}
      maxHeight="calc(100vh - 300px)"
      open={open}
      setOpen={setOpen}
      footer={
        <Grid2 container size={12} display={"flex"} justifyContent={"flex-end"}>
          <GKButton
            variant="contained"
            startIcon={<CheckIcon />}
            onClick={() => setOpen(false)}
          >
            Save
          </GKButton>
        </Grid2>
      }
    >
      <Grid2 container spacing={3}>
        <Grid2 size={12}>
          <GKClientDataGrid
            density="compact"
            loading={loading}
            columns={columns}
            rows={minesFeeData}
            name="minesFee"
            showHeaderGrid={false}
            pagination={false}
            checkboxSelection
            onRowSelectionModelChange={(params) => {
              setSelected(params as string[]);
            }}
            rowSelectionModel={selected}
            maxHeight={"calc(100vh - 600px)"}
          />
        </Grid2>
        <Grid2
          container
          size={12}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"flex-end"}
        >
          <Grid2 size={9} display={"flex"} justifyContent={"flex-end"}>
            <Typography fontSize={14} color="var(--grey-700)">
              Additional Management Fee:
            </Typography>
          </Grid2>
          <Grid2 size={3}>
            <Controller
              control={form.control}
              name="managementFee"
              render={({ field }) => (
                <GKTextField
                  {...field}
                  size="small"
                  placeholder="Amount"
                  type="number"
                  value={field.value ?? ""}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    field.onChange(e.target.valueAsNumber)
                  }
                  slotProps={{ input: { endAdornment: <RupeeIcon /> } }}
                />
              )}
            />
          </Grid2>
          <Grid2 size={9} display={"flex"} justifyContent={"flex-end"}>
            <Typography fontSize={14} fontWeight={600} color="var(--black)">
              Total Amount:
            </Typography>
          </Grid2>
          <Grid2 size={3}>
            <Typography
              fontSize={14}
              fontWeight={600}
              color="var(--black)"
              width={"100%"}
              textOverflow={"ellipsis"}
              overflow={"hidden"}
            >
              {numberToCurrency(totalAmount)}
            </Typography>
          </Grid2>
        </Grid2>
      </Grid2>
    </GKModal>
  );
};

export default MinesFeeModal;
